{
  "users": {
    "label": "Benutzer"
  },
  "userGroups": {
    "label": "Gruppen"
  },
  "userProfiles": {
    "label": "Profile"
  }
}
